import { openDB, DBSchema, deleteDB, IDBPDatabase } from 'idb';

const dbName = 'doctor-images';
const tableName = 'images';

const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  console.log(blob, 'b64toBlob.blob');

  return blob;
};

async function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.readAsDataURL(blob);
  });
}

interface DoctorImage extends DBSchema {
  images: {
    value: {
      image: string;
      size: number;
      type: string;
      date: Date;
      key: string;
    };
    key: string;
    indexes: { 'by-date': Date };
  };
}

let db: IDBPDatabase<DoctorImage>;

async function openDb() {
  if (db) return db;

  db = await openDB<DoctorImage>('doctor-images', 1, {
    upgrade(db) {
      const store = db.createObjectStore(tableName, {
        keyPath: 'key',
      });
      // Create an index on the 'date' property of the objects.
      store.createIndex('by-date', 'date');
    },
  });
  return db;
}

const doctorImageDb = {
  saveImage: async (key: number, image: Blob) => {
    const db = await openDb();
    //console.log(db, 'saveImage.db');
    //console.log(image, 'saveImage.image');

    const base64 = await blobToBase64(image);

    //console.log(base64, 'saveImage.base64');

    const start = base64.indexOf('base64,');
    if (start > 0) {
      await db?.put(tableName, {
        key: key + '',
        image: base64.slice(start + 7),
        size: image.size,
        type: image.type,
        date: new Date(),
      });
      //console.log(keyVal, 'saveImage.keyVal1');
    } else {
      await db?.put(tableName, {
        key: key + '',
        image: base64,
        size: image.size,
        type: image.type,
        date: new Date(),
      });
      //console.log(keyVal, 'saveImage.keyVal2');
    }
  },

  findImage: async (key: Number) => {
    const db = await openDb();
    //console.log(db, 'findImage.db');

    const img = await db?.get(tableName, key + '');
    //console.log(img, 'findImage.img');
    if (img) {
      return b64toBlob(img.image, img.type, img.size);
    }
    return undefined;
  },

  removeImage: async (key: Number) => {
    const db = (await openDb()) as IDBPDatabase;
    db?.delete(tableName, key + '');
  },

  clearImages: async () => {
    const db = (await openDb()) as IDBPDatabase;
    await db?.clear(tableName);
  },

  deleteDb: async () => {
    deleteDB(dbName);
  },
};

export default doctorImageDb;
